/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-expressions */
import { useEffect, useState } from 'react';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { Menu, MenuButton, MenuItem } from '@szhsin/react-menu';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { isAuthenticated } from 'actions/user';
// import { useSelector } from 'react-redux';
import { RaiseSupportTicket } from 'components/customicons';
import CustomLink from 'components/CustomLink/CustomLink';
import { disableScrolling, enableScrolling } from 'components/Header/partials/get_change';
import {
  ALGO_API_PAGE,
  ANDROID_APK_URL,
  APP_STORE_URL,
  BACKUP_PAGE_URL,
  DOCS_URL,
  IS_DEMO,
  IS_INDIAN_EXCHANGE,
  // LANDING_PAGE_URL,
  PLATFORM_STATUS_URL,
  PLAY_STORE_URL,
  PROD_ENV,
  SUPPORT_CENTER_LINK_HOME,
  SUPPORT_TICKET_URL,
  TESTNET_URL,
  YOUTUBE_LINK,
} from 'constants/constants';
import routes from 'constants/routes';
import { USER_GUIDE_URL } from 'constants/urls';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { isVisibleInViewport, noop } from 'helpers/utils';
import useLanguageChange from 'hooks/useLanguageChange';
import i18n from 'i18n/config';
import AppStore from 'styles/assets/appStoreBadge.png';
import DownloadAndroid from 'styles/assets/downloadandroid.svg';
import GooglePlay from 'styles/assets/googlePlayBadge.png';
import {
  // FranceIcon,
  // PortugeseIcon,
  // TurkeyIcon,
  // AnalyticsIcon,
  AngleLeft,
  AnnouncementIcon,
  ApiDocsIcon,
  ArrowSide,
  BlogIcon,
  ContractSpecificationIcon,
  GlobalIcon,
  InsuranceFundIcon,
  LanguageIcon,
  MobileIcon,
  MockTrading,
  NineSquareIcon,
  RaiseSupportIcon,
  RightArrowIcon,
  SettlementPrices,
  StatusIcon,
  SupportCenterIcon,
  // TradeHistoryIcon,
  TradingFeesIcon,
  UserGuideIcon,
  YoutubeRedIcon,
} from 'styles/assets/icons';
// import { refreshCacheAndReload } from 'helpers/mixpanel-init';
import AlgoApisIcon from 'styles/assets/icons/AlgoApisIcon';
import TradeData from 'styles/assets/icons/TradeData';
import MobileAppQRCode from 'styles/assets/mobileAppQrCode.svg';
import DeltaButton from 'UIKit/DeltaButton';
import IconButton from 'UIKit/IconButton';

import styles from './index.module.scss';

// import { isAuthenticated } from 'actions/user';
const MENU_TITLE_MAX_LENGTH = 22;

export const helpMenuLeft = [
  {
    id: 0,
    label: 'Raise Support Ticket',
    link: SUPPORT_TICKET_URL,
    icon: <RaiseSupportIcon className={cn(styles['left-icon'], styles['all-icon'])} />,
    target: '_blank',
    rel: 'noopener noreferrer',
    key: 'raiseSupportTicket',
  },
  {
    id: 1,
    label: 'Support Center',
    link: SUPPORT_CENTER_LINK_HOME,
    icon: <SupportCenterIcon className={cn(styles['left-icon'], styles['all-icon'])} />,
    target: '_blank',
    rel: '',
    key: 'supportCenter',
  },
  {
    id: 1,
    label: 'User Guide',
    link: USER_GUIDE_URL,
    icon: <UserGuideIcon className={cn(styles['left-icon'], styles['all-icon'])} />,
    target: '_blank',
    rel: 'noopener noreferrer',
    key: 'userGuide',
  },
];

export const helpMenuRight = [
  // {
  //   id: 0,
  //   label: 'Feedback',
  //   link: `/feedback-form`,
  //   icon: <FeedBackIcon className={cn(styles['left-icon'], styles['all-icon'])} />,
  //   target: '_blank',
  //   rel: '',
  //   key: 'feedback',
  // },
];

export const supportMenu = loggedIn => {
  return [
    // !loggedIn && {
    //   id: 0,
    //   label: 'Raise a Support Ticket',
    //   link: `https://delta.exchange/support-ticket`,
    //   icon: (
    //     <RaiseSupportTicket
    //       className={cn(styles['left-icon'], styles['all-icon'])}
    //     />
    //   ),
    //   target: '_blank',
    //   rel: 'noopener noreferrer',
    //   key: 'raiseSupportTicket',
    // },
    !loggedIn &&
      !IS_DEMO && {
        id: 0,
        label: 'Raise a Support Ticket',
        link: SUPPORT_TICKET_URL,
        icon: <RaiseSupportTicket className={styles['left-icon']} />,
        target: '_blank',
        rel: 'noopener noreferrer',
        key: 'raiseSupportTicket',
      },
    {
      id: 1,
      label: 'Support Center',
      link: '/support',
      icon: <SupportCenterIcon className={cn(styles['left-icon'], styles['all-icon'])} />,
      target: '_blank',
      rel: '',
      key: 'supportCenter',
    },
  ].filter(Boolean);
};

export const resourcesMenu = [
  !IS_DEMO &&
    !IS_INDIAN_EXCHANGE && {
      id: 'f',
      label: 'Demo Trading',
      link: TESTNET_URL,
      icon: <MockTrading className={cn(styles['left-icon'], styles['all-icon'])} />,
      target: '_blank',
      rel: '',
      key: 'demoTrading',
    },
  !IS_INDIAN_EXCHANGE && {
    id: 'g',
    label: 'Trade History',
    link: `/app${routes.tradeHistory}`,
    icon: (
      <TradeData
        fill1="var(--dropdownIconColor)"
        fill2="var(--dropdownIconColor)"
        fill3="var(--dropdownIconColor)"
        width={20}
        height={20}
        className={cn(styles['left-icon'], styles['all-icon'])}
      />
    ),
    target: '_self',
    rel: 'noopener noreferrer',
    key: 'tradeHistory',
  },
  // !IS_INDIAN_EXCHANGE && {
  //   id: 'h',
  //   label: 'Analytics',
  //   link: 'https://www.delta.exchange/data-analytics/',
  //   icon: <AnalyticsIcon className={cn(styles['left-icon'], styles['all-icon'])} />,
  //   target: '_blank',
  //   rel: 'noopener noreferrer',
  //   key: 'ivData',
  // },

  {
    id: 'i',
    label: 'API Docs',
    link: `${DOCS_URL}/#introduction`,
    icon: <ApiDocsIcon className={cn(styles['left-icon'], styles['all-icon'])} />,
    target: '_blank',
    rel: 'noopener noreferrer',
    key: 'apiDoc',
  },
  {
    id: 'j',
    label: 'Blog',
    link: '/blog',
    icon: <BlogIcon className={cn(styles['left-icon'], styles['all-icon'])} />,
    target: '_blank',
    rel: 'noopener noreferrer',
    key: 'blog',
  },
  {
    id: 'apis',
    label: 'Algo APIs',
    link: ALGO_API_PAGE,
    icon: (
      <AlgoApisIcon
        className={cn(styles['left-icon'], styles['all-icon'], styles.algoApisIcon)}
        fill="var(--dropdownIconColor)"
      />
    ),
    target: '_self',
    rel: '',
    key: 'apis',
  },
];

export const informationMenu = [
  {
    id: 'a',
    label: 'Trading Fees',
    link: '/fees',
    icon: <TradingFeesIcon className={cn(styles['left-icon'], styles['all-icon'])} />,
    target: '_blank',
    rel: '',
    key: 'tradingFees',
  },
  !IS_DEMO && {
    id: 'b',
    label: 'Contract Specifications',
    link: '/contracts',
    icon: (
      <ContractSpecificationIcon
        className={cn(styles['left-icon'], styles['all-icon'])}
      />
    ),
    target: '_blank',
    rel: '',
    key: 'contractSpecs',
  },
  {
    id: 'c',
    label: 'Settlement Prices',
    link: `${
      process.env.REACT_APP_ENV === PROD_ENV.PROD_BACKUP ? BACKUP_PAGE_URL : ''
    }/app/expired_futures_and_options`,
    icon: <SettlementPrices className={cn(styles['left-icon'], styles['all-icon'])} />,
    target: '_blank',
    rel: '',
    key: 'settlementPrices',
  },
  {
    id: 'd',
    label: 'Insurance Fund',
    link: '/insurance-fund',
    icon: <InsuranceFundIcon className={cn(styles['left-icon'], styles['all-icon'])} />,
    target: '_blank',
    rel: '',
    key: 'insuranceFund',
  },
  {
    id: 'e',
    label: 'Status',
    link: PLATFORM_STATUS_URL,
    icon: <StatusIcon className={cn(styles['left-icon'], styles['all-icon'])} />,
    target: '_blank',
    rel: '',
    key: 'status',
  },
];

export const telegramChannelOne = [
  {
    id: '0',
    label: 'Announcement',
    link: `https://t.me/delta_ex_official`,
    icon: <AnnouncementIcon className={cn(styles['left-icon'], styles['all-icon'])} />,
    target: '_blank',
    rel: '',
    key: 'announcements',
  },
  {
    id: 'w',
    label: 'Global',
    link: `https://t.me/deltaexchat`,
    icon: (
      <GlobalIcon
        className={cn(styles['left-icon'], styles['all-icon'], styles.globeIcon)}
      />
    ),
    target: '_blank',
    rel: '',
    key: 'global',
  },
];

const youtubeCommunityTxt = i18n.t('headerFooter:header.sideMenu.youtubeCommunityTxt');

const PrimarySideMenuGlobal = () => {
  const isLoggedIn = useSelector(({ user }) => isAuthenticated(user));
  const { t } = useTranslation(['headerFooter']);
  const [isSideMenuOpen, setSideMenuOpen] = useState(false);
  const [isLanguageMenuOpen, setLanguageMenuOpen] = useState(false);
  const [isAppMenuOpen, setAppMenuOpen] = useState(false);
  const { activeLanguage, availableLocales, handleLanguageSwitch } =
    useLanguageChange(false);
  const getLocalizedValue = key => {
    const str = `headerFooter:header.sideMenu.${key}`;
    return t(str);
  };
  const handleClose = () => {
    setSideMenuOpen(false);
  };

  useEffect(() => {
    isSideMenuOpen ? disableScrolling() : enableScrolling();
  }, [isSideMenuOpen]);

  const handleKeyPress = event => {
    if (event.key === 'Escape') {
      setSideMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => document.removeEventListener('keydown', handleKeyPress);
  }, []);

  const onLanguageChange = locale => {
    trackMixpanelEvent('Language Changed - All Pages', {
      language_selected: locale,
    });
    handleLanguageSwitch(locale);
  };

  const handleLanguageMenu = () => {
    setLanguageMenuOpen(true);
  };

  const handleAppDownloadMenu = () => {
    setAppMenuOpen(true);
  };

  const closeAppMenu = e => {
    e.stopPropagation();
    setAppMenuOpen(false);
  };
  const closeLanguageMenu = e => {
    e.stopPropagation();
    setLanguageMenuOpen(false);
  };

  const onMenuItemClick = label => {
    setSideMenuOpen(false);
    trackMixpanelEvent(`${label} - All Pages - 3 dot menu`);
  };

  const onYoutubeClick = () => {
    setSideMenuOpen(false);
    trackMixpanelEvent(
      'Youtube button clicked  - Three Dots Menu Clicked - All Pages - Header'
    );
  };

  const onMenuClick = () => {
    setSideMenuOpen(!isSideMenuOpen);
    setLanguageMenuOpen(false);
    setAppMenuOpen(false);
    trackMixpanelEvent(`Three Dots Menu clicked - All Pages - Header`);
  };

  // const onClearCacheClick = () => {
  //   trackMixpanelEvent('Clear Cache - All Pages - 3 dot menu');
  //   refreshCacheAndReload();
  // };
  // const onClearCacheClick = () => {
  //   trackMixpanelEvent('Clear Cache - All Pages - 3 dot menu');
  //   refreshCacheAndReload('PrimarySideMenu');
  // };

  // const isTickerVisibleOnScreen=()=>{
  //   const element = document.querySelector('.ticker');

  //   if (element === null) return false;

  //   const style = window.getComputedStyle(element);
  //   return (style.display !== 'none')
  // }

  const tickerTape = document.querySelector('.ticker');

  return (<>
    <ClickAwayListener onClickAway={handleClose}>
      <div className={styles.primarySideMenu}>
        <Menu
          menuButton={({ open }) => (
            <MenuButton
              data-testid="nine-squares-icon-btn"
              className={`${open ? styles.active : ''} ${styles.button}`}
              onClick={onMenuClick}
            >
              <NineSquareIcon className={styles.nineSquareIconContainer} />
            </MenuButton>
          )}
          menuClassName={`${styles['menu-container']} ${
            isVisibleInViewport(tickerTape) ? styles['reduce-height'] : ' '
          }`}
          direction="right"
        >
          {!isLanguageMenuOpen && !isAppMenuOpen && isLoggedIn && (
            <MenuItem
              data-testid="language-app-menu"
              onClick={e => {
                const event = e;
                event.keepOpen = true;
              }}
              className={styles.settingsMenu}
            >
              {!IS_INDIAN_EXCHANGE && (
                <DeltaButton
                  data-testid="language-settings"
                  className={styles.languageMenu}
                  wrapperClassName={styles.languageContainer}
                  onClick={handleLanguageMenu}
                >
                  <LanguageIcon />
                  <div className={styles.languageText}>
                    {getLocalizedValue('language')}
                  </div>
                  <span className={styles.activeLanguage}>{activeLanguage}</span>
                  <ArrowSide className={styles.rightArrow} />
                </DeltaButton>
              )}
              <DeltaButton
                data-testid="download-app-menu"
                className={styles.appMenu}
                wrapperClassName={styles.appContainer}
                onClick={handleAppDownloadMenu}
              >
                <MobileIcon />
                <div className={styles.heading}>{getLocalizedValue('appDownload')}</div>
                <ArrowSide className={styles.rightArrow} />
              </DeltaButton>
            </MenuItem>
          )}
          {isAppMenuOpen && (
            <MenuItem
              data-testid="app-download-menu"
              className={styles.downloadAppMenu}
              onClick={() => setSideMenuOpen(false)}
            >
              <div className={styles.appMenuHeader}>
                <IconButton
                  className={styles.backBtn}
                  onClick={e => closeAppMenu(e)}
                  testID="language-menu"
                  data-testid="back-btn"
                  icon={<AngleLeft />}
                  onKeyDown={noop}
                />
                <div className={styles.heading}>{getLocalizedValue('appDownload')}</div>
              </div>
              <div className={styles.downloadMenu}>
                <div className={styles.heading}>
                  {getLocalizedValue('downloadIosAndAndroidApp')}
                </div>
                <div className={styles.qrCode}>
                  <img
                    src={MobileAppQRCode}
                    alt="mobile_app_qr_code"
                    width="135px"
                    height="135px"
                  />
                </div>
                <div className={styles.downloadOptions}>
                  <div className={styles.appStore}>
                    <a
                      data-testid="app-store"
                      onClick={() =>
                        trackMixpanelEvent('iOS Download - Header', {
                          page_name: 'All Markets Page',
                        })
                      }
                      href={APP_STORE_URL}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={AppStore} width="135px" height="40px" alt="app-store" />
                    </a>
                  </div>
                  <div className={styles['play-store']}>
                    <a
                      data-testid="play-store"
                      onClick={() =>
                        trackMixpanelEvent('Android Download - Header', {
                          page_name: 'All Markets Page',
                        })
                      }
                      href={PLAY_STORE_URL}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={GooglePlay}
                        width="135px"
                        height="40px"
                        alt="google-play"
                      />
                    </a>
                  </div>

                  <div className={styles['play-store']}>
                    <a
                      data-testid="android-apk"
                      onClick={() =>
                        trackMixpanelEvent('Android Download - Header', {
                          page_name: 'All Markets Page',
                        })
                      }
                      href={ANDROID_APK_URL}
                      rel="noreferrer"
                    >
                      <img
                        src={DownloadAndroid}
                        width="135px"
                        height="40px"
                        alt="android-app"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </MenuItem>
          )}
          {isLanguageMenuOpen && (
            <MenuItem
              className={styles.languageOptionsMenu}
              data-testid="language-menu"
              onClick={() => setSideMenuOpen(false)}
            >
              <div className={styles.languageHeader}>
                <IconButton
                  className={styles.backBtn}
                  onClick={e => closeLanguageMenu(e)}
                  testID="language-menu"
                  data-testid="back-btn"
                  icon={<AngleLeft />}
                  onKeyDown={noop}
                />
                <div className={styles.heading}>{getLocalizedValue('language')}</div>
              </div>
              <div
                data-testid="language-sub-menu"
                aria-hidden="true"
                className={styles.languageOptions}
                onClick={e => e.stopPropagation()}
              >
                {Object.keys(availableLocales).map(locale => {
                  return (
                    <DeltaButton
                      className={cn(styles.languageBtn, {
                        [styles.active]: activeLanguage === locale,
                      })}
                      data-testid={`language-btn-${locale}`}
                      onClick={() => onLanguageChange(locale)}
                    >
                      {locale} {availableLocales[locale]}
                    </DeltaButton>
                  );
                })}
              </div>
            </MenuItem>
          )}
          {!isLanguageMenuOpen && !isAppMenuOpen && !IS_INDIAN_EXCHANGE && (
            <MenuItem
              data-testid="youtubeLink"
              href={YOUTUBE_LINK}
              className={styles[`youtube-wrapper`]}
              onClick={onYoutubeClick}
              target="_blank"
            >
              <div>
                <YoutubeRedIcon />
              </div>
              <div className={styles[`youtube-text`]}>{youtubeCommunityTxt}</div>
            </MenuItem>
          )}
          {!isLanguageMenuOpen && !isAppMenuOpen && (
            <MenuItem
              data-testid="information-menu"
              className={`${styles[`info-res-wrapper`]} ${
                IS_INDIAN_EXCHANGE && styles['mt-20']
              }`}
              onClick={() => setSideMenuOpen(false)}
            >
              <div>
                <div className={styles[`info-header`]}>
                  {getLocalizedValue('information')}
                </div>
                {informationMenu.filter(Boolean).map((item, ind) => {
                  const title = getLocalizedValue(item.key);

                  return (
                    (<div
                      key={`${ind}-${item.id}`}
                      className={cn('truncate', styles[`info-menu`])}
                      data-palette="PrimarySideMenuGlobal">
                      <CustomLink
                        data-testid={`informationMenu-${item.id}`}
                        href={item.link}
                        target={item.target}
                        rel={item.rel}
                        onClick={() => onMenuItemClick(item.label)}
                      >
                        {item.icon}{' '}
                        <span
                          title={title.length > MENU_TITLE_MAX_LENGTH ? title : ''}
                          className={styles.label}
                        >
                          {title}
                        </span>{' '}
                        <RightArrowIcon className={styles['right-arrow']} />
                      </CustomLink>
                    </div>)
                  );
                })}
              </div>
              <div>
                <div className={styles[`info-header`]}>
                  {getLocalizedValue('resources')}
                </div>
                {resourcesMenu.filter(Boolean).map((item, ind) => {
                  const title = getLocalizedValue(item.key);
                  return (
                    (<div
                      key={`${ind}-${item.id}`}
                      className={cn('truncate', styles[`info-menu`])}
                      data-palette="PrimarySideMenuGlobal">
                      <CustomLink
                        data-testid={`resourcesMenu-${item.id}`}
                        href={item.link}
                        target={item.target}
                        rel={item.rel}
                        onClick={() => onMenuItemClick(item.label)}
                      >
                        {item.icon}{' '}
                        <span
                          title={title.length > MENU_TITLE_MAX_LENGTH ? title : ''}
                          className={styles.label}
                        >
                          {title}
                        </span>{' '}
                        <RightArrowIcon className={styles['right-arrow']} />
                      </CustomLink>
                    </div>)
                  );
                })}
              </div>
            </MenuItem>
          )}
          {!isAppMenuOpen && !isLanguageMenuOpen && (
            <MenuItem
              data-testid="help-menu"
              onClick={() => setSideMenuOpen(false)}
              className={styles['help-tele-wrapper']}
            >
              <div>
                <div className={styles[`help-header`]}>{getLocalizedValue('help')}</div>
                <div className={styles[`help-sub-container`]}>
                  <div className={styles[`menu-cont`]}>
                    {helpMenuLeft.map((item, ind) => (
                      <div
                        key={`${ind}-${item.id}`}
                        className={cn('truncate', styles[`menu-item`])}
                        data-palette="PrimarySideMenuGlobal">
                        <CustomLink
                          data-testid={`helpMenu-${item.id}`}
                          href={item.link}
                          target={item.target}
                          rel={item.rel}
                          onClick={() => onMenuItemClick(item.label)}
                        >
                          {item.icon}{' '}
                          <span
                            title={
                              getLocalizedValue(item.key).length > MENU_TITLE_MAX_LENGTH
                                ? getLocalizedValue(item.key)
                                : ''
                            }
                            className={styles.label}
                          >
                            {getLocalizedValue(item.key)}
                          </span>{' '}
                          <RightArrowIcon className={styles['right-arrow']} />
                        </CustomLink>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div>
                <div className={styles[`help-header`]}>
                  {getLocalizedValue('telegram')}
                </div>
                <div className={styles[`tele-box`]}>
                  {telegramChannelOne.map((item, ind) => (
                    <div
                      key={`${ind}-${item.id}`}
                      className={styles[`menu-item`]}
                      data-palette="PrimarySideMenuGlobal">
                      <CustomLink
                        data-testid={`telegramChannel-${item.id}`}
                        href={item.link}
                        target={item.target}
                        onClick={() => onMenuItemClick(item.label)}
                      >
                        {item.icon}
                        <span className={styles.label}>
                          {getLocalizedValue(item.key)}
                        </span>{' '}
                        <RightArrowIcon className={styles['right-arrow']} />
                      </CustomLink>
                    </div>
                  ))}
                </div>
              </div>
            </MenuItem>
          )}
        </Menu>
      </div>
    </ClickAwayListener>
    {isSideMenuOpen && <div className={styles.overlay} data-palette="PrimarySideMenuGlobal" />}
  </>);
};

export default PrimarySideMenuGlobal;
